import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { fetchRace } from "../../../../redux/getReducer/getCard";

import TodayRaceCard from "../../../../pages/TodayRaceCard";
import Result from "../../Components/Result";
import RaceCardDetail from "../../../../pages/RaceCardDetail";
import { useTranslation } from "react-i18next";
import headerIcon from "../../../../assets/image 4.png";
import RaceCardSlider from "../RaceCardSlider";
const LiveAntennaIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: "8px" }}
  >
    <circle cx="12" cy="12" r="2"></circle>
    <path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>
  </svg>
);

export default function HomeTabs({ raceCardData }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Live");

  const { id } = useParams();
  const hash = window.location.hash;
  const decodedDate = binaryToDate(hash.replace("#", ""));

  const location = useLocation();
  const id2 = location.search.slice(1);

  const { data: Card } = useSelector((state) => state.Card);
  const { data: racecard, status } = useSelector((state) => state.racecard);
  const { data: raceresult } = useSelector((state) => state.raceresult);

  function binaryToDate(binaryString) {
    const timestamp = parseInt(binaryString, 2);
    return new Date(timestamp);
  }

  useEffect(() => {
    if (id && decodedDate) {
      dispatch(fetchRace({ calenderid: id, convertedDate: decodedDate }));
    }
  }, [id, dispatch, hash]);

  const apiCheck = Card && Card.length > 0 ? Card[0] : null;

  useEffect(() => {
    if (hash) {
      // If user selected a date from calendar, show that
      setActiveTab("Racelisting");
    } else if (raceresult && raceresult.length > 0) {
      // If no calendar selection, but Live data exists, show Live
      setActiveTab("Live");
    } else if (apiCheck?.RaceCourseData?.[0]?.Day) {
      // Fallback to Racelisting if that has data
      setActiveTab("Racelisting");
    }
  }, [hash, raceresult?.length, apiCheck?.RaceCourseData?.[0]?.Day]);

  const fullPath = `/race-detail?${id2}`;

  return (
    <div className="race-card-post-unique-wrapper">
      <style>
        {`
          .race-card-post-unique-wrapper {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            width: 100%;
            
          }
          .race-card-post-unique-wrapper .RaceCard{
          background-color: #ffffff !important; 
          }
          
          .rcp-main-heading {
            font-size: 24px !important;
            font-weight: 800 !important;
            color: #000 !important;
            margin-bottom: 20px !important;
            text-transform: uppercase !important;
          }

         .rcp-outer-box {
            background-color: #ffffff !important; 
            border: 1px solid #e2e8f0 !important;
            border-radius: 12px !important;
            padding: 25px 20px !important; 
            box-shadow: 0 4px 15px rgba(0,0,0,0.04) !important;
            min-height: 725px;
            height: auto;
          }

          .race-card-post-unique-wrapper .tab-content {
            padding: 0 !important;
            margin: 0 !important;
            background: transparent !important;
          }

          @media (max-width: 768px) {
            .rcp-outer-box { padding: 15px 10px; min-height: auto; }
          }
        `}
      </style>


      <div className="rcp-outer-box">
        {racecard.length > 0 && activeTab === "Live" ? (
          <div className="">
            <RaceCardSlider />

            <div className="d-flex">
              <div className="race-post-header">
                <h2 className="race-post-title">{t("today_race")}</h2>
              </div>
              <div className="race-post-logo-wrap">
                <img
                  src={headerIcon}
                  alt="icon"
                  style={{ width: "45px", opacity: 0.3, margin: "0 0 4px 0px" }}
                />
              </div>
            </div>
          </div>

        )
          :
          (
            <div className="d-flex">
              <div className="race-post-header">
                <h2 className="race-post-title">{t("RACE CARD POST")}</h2>
              </div>
              <div className="race-post-logo-wrap">
                <img
                  src={headerIcon}
                  alt="icon"
                  style={{ width: "45px", opacity: 0.3, margin: "0 0 4px 0px" }}
                />
              </div>
            </div>
          )
        }

        {location.pathname + location.search === fullPath ? (
          <>
            <RaceCardDetail />
          </>
        ) : (
          <div className="tab-content">
            {activeTab === "Live" ? (
              <div className="tab-pane active liveResult">
                <Result />
              </div>
            ) : (
              <div className="tab-pane active">

                <TodayRaceCard />
              </div>
            )}
          </div>

        )}
      </div>
    </div >
  );
}
